import PropTypes from 'prop-types';
import React from "react";
import autobind from "autobind-decorator";

import ChartWrapper from "./ChartWrapper.jsx";
import * as Modal from "./Modal.jsx";

export default class ViewManager extends React.Component {
    static propTypes = {
        actions:  PropTypes.objectOf(PropTypes.func),
        charts: PropTypes.array,
        embedded: PropTypes.bool,
        selected: PropTypes.number,
        exposed: PropTypes.bool
    };

    static displayName = 'ViewManager';

    componentDidMount() {
        if (!this.props.embedded) {
            window.addEventListener("keydown", this._handleKeyPress);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this._handleKeyPress);
    }

    @autobind
    _handleKeyPress(e) {
        const {selected, charts, actions} = this.props;
        const {addChart, expose, selectChart, moveChart, deleteChart} = actions;

        const tagRex = /^(button|input|textarea|select)$/i;
        if (e.target.tagName && e.target.tagName.match(tagRex)) {
            return;
        }

        if (Modal.isOpen()) {
            return;
        }

        if (e.shiftKey && (e.keyCode !== 37 && e.keyCode !== 39) ||
            e.metaKey || e.ctrlKey || e.altKey) {
            return;
        }

        var key = String.fromCharCode(e.keyCode).toLowerCase();

        if (e.keyCode === 38) {
            //up
            expose(false);
        } else if (e.keyCode === 40) {
            //down
            expose(true);
        } else if (e.keyCode === 39) {
            if (e.shiftKey) {
                moveChart(selected, 1);
            }

            e.preventDefault();
            selectChart(selected + 1);
        } else if (e.keyCode === 37) {
            if (e.shiftKey) {
                moveChart(selected, -1);
            }

            e.preventDefault();
            selectChart(selected - 1);
        } else if (e.keyCode === 46) {
            //delete
            if (charts[selected]) {
                deleteChart(selected);
                if (charts.length - 1 === selected) {
                    selectChart(selected - 1);
                }
            }
        } else if (key === "n") {
            //create new chart
            let last = charts.length;
            addChart({});
            selectChart(last);
            expose(false);
        } else if (key === "d" && charts.length) {
            //duplicate current
            let current = charts[selected];
            let last = charts.length;
            addChart({...current});
            setTimeout(()=> selectChart(last), 0);
        }
    }

    componentDidUpdate(prevProps) {
        let {selected, charts, actions} = this.props;

        // "bounce" back if invalid chart is selected
        if (selected < 0 || selected >= charts.length) {
            let limit = Math.max(Math.min(selected, charts.length - 1), 0);
            setTimeout(()=>actions.selectChart(limit), 30);
        }
    }

    render() {
        let {selected, charts, exposed, ...otherProps} = this.props;

        selected = Math.max(Math.min(charts.length - 0.98, selected), -0.02);

        let tx = "translate3d(" + (-100 * selected) + "vw, 0, 0)";
        let styles = {
            width: Math.max(charts.length, 1) + "00vw",
            transform: tx,
            WebkitTransform: tx
        };

        return (
            <charts className={exposed ? "expose" : ""} style={styles}>
                {charts.map((chart, i)=> {
                    return (
                    <ChartWrapper
                        chart={chart}
                        index={i}
                        isSelected={i === Math.round(selected)}
                        isExposed={exposed}
                        key={"" + chart.id}
                        {...otherProps}
                    />
                    );
                })}
            </charts>
        );
    }
}


// WEBPACK FOOTER //
// ./src/kpi/components/ViewManager.jsx